import React from 'react'

import './Header.scss'

export interface ModalHeaderProps {
  children: React.ReactNode
  showDivider?: boolean
  'data-testid'?: string
}

const ModalHeader = React.memo(
  ({
    children,
    showDivider,
    'data-testid': dataTestId = 'modal-header',
  }: ModalHeaderProps) => {
    return (
      <header
        className={[
          'ModalHeader',
          showDivider ? 'ModalHeader--with-divider' : '',
        ].join(' ')}
        data-testid={dataTestId}
      >
        {children}
      </header>
    )
  },
)

ModalHeader.displayName = 'Modal.Header'

export default ModalHeader
